import { isRecord } from './parsingHelpers';

export const getThreadMetricsLastCapturedAt = (
    metadata: unknown,
): string | null => {
    if (!isRecord(metadata)) {
        return null;
    }

    const metrics = metadata.metrics;
    if (!isRecord(metrics)) {
        return null;
    }

    const lastCapturedAt = metrics.lastCapturedAt;
    if (typeof lastCapturedAt === 'string' && lastCapturedAt !== '') {
        return lastCapturedAt;
    }

    return null;
};

export const getThreadScorersLastScoredAt = (
    metadata: unknown,
): string | null => {
    if (!isRecord(metadata)) {
        return null;
    }

    const scorers = metadata.scorers;
    if (!isRecord(scorers)) {
        return null;
    }

    const lastScoredAt = scorers.lastScoredAt;
    if (typeof lastScoredAt === 'string' && lastScoredAt !== '') {
        return lastScoredAt;
    }

    return null;
};

/**
 * A thread needs an eval when it has neither metrics nor scorers metadata
 * from a prior eval pass.
 */
export const threadNeedsEval = (metadata: unknown): boolean =>
    getThreadMetricsLastCapturedAt(metadata) == null &&
    getThreadScorersLastScoredAt(metadata) == null;
